// src/views/MainPage.jsx (or MainPage.js)
import React from 'react';
import { Link } from 'react-router-dom';

const MainPage = () => {
    const links = [
        { to: '/cinnamon-design-1', label: 'Design 01 – Home' },
        { to: '/cinnamon-design-2', label: 'Design 02 – Home' },
        { to: '/cinnamon-design-3', label: 'Design 03 – Home' },
        { to: '/cinnamon-design-4', label: 'Design 04 – Home' },
        { to: '/cinnamon-design-5', label: 'Design 05 – Home' },
        { to: '/cinnamon-design-6', label: 'Design 06 – Home' },
    ];

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="w-full max-w-5xl mx-auto px-6 py-10">
                <div className="text-center mb-10">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800">
                        Welcome to Claude&apos;s Special
                    </h1>
                    <p className="mt-3 text-gray-600">
                        Jump to any design using the buttons below.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {links.map(({ to, label }) => (
                        <Link
                            key={to}
                            to={to}
                            className="group rounded-xl border border-orange-200 bg-white/70 backdrop-blur hover:bg-white transition-all shadow-sm hover:shadow-md px-5 py-4 flex items-center justify-between"
                        >
                            <span className="font-semibold text-gray-800">{label}</span>
                            <span className="ml-3 inline-flex items-center justify-center rounded-lg bg-gradient-to-r from-orange-500 to-red-500 text-white w-9 h-9 transition-transform group-hover:translate-x-1">
                                →
                            </span>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MainPage;
